import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

import { PrismSnackbarService } from '@shure/prism-angular-components';

/**
 * Route that gets executed if a claiming URL is invalid. It shows a snackbar to the user and redirects to /devices.
 */
@Component({
	selector: 'sh-claim-invalid-url-route',
	imports: [TranslocoModule],
	standalone: true,
	template: ''
})
export class ClaimInvalidUrlRouteComponent implements OnInit {
	constructor(
		private readonly snackbarService: PrismSnackbarService,
		private readonly transloco: TranslocoService,
		private readonly router: Router
	) {}

	public ngOnInit(): void {
		this.snackbarService.open({
			message: this.transloco.translate('cloud.device-management.inventory.invalid-claim-url-message'),
			actionText: this.transloco.translate('common.buttons.close')
		});
		this.router.navigate(['devices', 'add'], { replaceUrl: true });
	}
}
